import { LiaUserPlusSolid } from "react-icons/lia";
import { useState } from 'react';
import ReportDescriptionModal from './ReportDescriptionModal';

const NewEnrollmentsChart = ({report}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const totalCount = report?.lines?.find(line => line.key === 'total_count')?.value || 0;

  return (
    <>
      <div className='flex items-center gap-2 mb-4'>
        <LiaUserPlusSolid className="text-xl text-blue-600" />
        <h3 className='text-lg font-semibold text-gray-900'>{report?.title || 'Novas Matrículas'}</h3>
        {report?.description && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-500 transition-colors duration-200"
          >
            <span className="text-white text-xs font-bold">?</span>
          </button>
        )}
      </div>
      
      <div className="flex flex-col items-center justify-center h-80 text-center">
        <div className="mb-4">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-4 mx-auto">
            <LiaUserPlusSolid className="text-3xl text-blue-600" />
          </div>
          <h4 className="text-lg font-semibold text-gray-900 mb-2">Total de Novas Matrículas</h4>
        </div>
        
        <div className="text-6xl font-bold text-gray-900 mb-2">
          {parseInt(totalCount).toLocaleString()}
        </div>
        
        <p className="text-lg text-gray-500">alunos</p>
      </div>
      
      <ReportDescriptionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={report?.title || 'Novas Matrículas'}
        description={report?.description}
      />
    </>
  );
};

export default NewEnrollmentsChart;
